var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatbubbleReply = function SvgChatbubbleReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.4 11.8c.2.2.3.5.2.8l-.9 4.3c-.1.4.3.7.6.5L6 15c.2-.1.4-.1.6-.1.2 0 .5.1.8.1l5-5c.9-.9 2.2-1.1 3.3-.6.4-.8 1.3-1.4 2.3-1.5 0-4-4-7.3-9-7.3S0 3.9 0 7.9c0 1.4.5 2.7 1.4 3.9zm16.8-1.7c.6 0 1 .4 1 1v1.1c0 2.4-1.9 4.3-4.3 4.3h-1.5l1.6 1.6c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-4-4 4-4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-1.6 1.6h1.5c1.3 0 2.3-1 2.3-2.3v-1.1c0-.5.5-1 1-1z",
    clipRule: "evenodd"
  })));
};
export default SvgChatbubbleReply;